import PropTypes from 'prop-types';
import React from 'react';
import { MicroAppLoader } from '../biz-components/micro-app-loader';
import StepDone from '../biz-components/step-done';
import { getW4Entry } from '../tax-form-utils';

function RemoteW4v0(props) {
  const {
    processData,
    company,
    action,
    onSignedSuccess,
    viewResultAsManager,
  } = props;

  if (viewResultAsManager) {
    return (
      <StepDone text="This step has been completed." />
    );
  }

  const env = process.env.DEPLOY_ENV;

  return (
    <MicroAppLoader
      name="w4-v0"
      // entry="http://192.168.31.106:8015"
      entry={getW4Entry(env).v0}
      componentProps={{
        employeeId: (processData || {}).employee_record_uuid,
        triggerId: ((action || {}).w4_form_answer || {}).digest_key,
        coreCompanyId: (company || {}).uuid,
        env,
        onSignedSuccess,
      }}
    />
  );
}

RemoteW4v0.defaultProps = {
  viewResultAsManager: false,
};

RemoteW4v0.propTypes = {
  company: PropTypes.shape().isRequired,
  processData: PropTypes.shape().isRequired,
  action: PropTypes.shape().isRequired,
  onSignedSuccess: PropTypes.func.isRequired,
  viewResultAsManager: PropTypes.bool,
};

export default RemoteW4v0;
